<template>
    <div class="landing-page-trade px-md-5 px-lg-0">
        <div class="trade-in-your-home text-center">
            <h1
                class="main-title font-weight-bold"
            >
                Trade In Your Home
                <b-badge
                    variant="danger"
                    pill
                >
                    NEW
                </b-badge>
            </h1>

            <p class="sub-title">
                Buy a new home, <i>then</i> sell your existing home for full price.
            </p>
        </div>

        <resources/>

        <get-started
            @click="handleClick"
        />

        <hr
            class="text-gray-400 add-ons-line"
        />

        <div class="how-it-works text-center">
            <h1
                class="main-title font-weight-bold"
            >
                How It Works
            </h1>
            <p class="sub-title">
                The process is easy, and designed to make your transition stress-free.
            </p>
        </div>

        <tutorial/>

        <hr
            class="text-gray-400 add-ons-line"
        />

        <div class="how-it-works text-center">
            <h1
                class="main-title font-weight-bold"
            >
                Ready To Trade In Your Home?
            </h1>
            <p class="sub-title">
                I'll help you understand how to secure the home you really want, then confidently
                sell your existing home.
            </p>
        </div>

        <get-started
            class="bottom"
            @click="handleClick"
        />

        <contact-modal/>
    </div>
</template>

<script>
import './Trade.scss';
import './Trade.mobile.scss';
import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
import LandingPageTradeSectionAppResource
    from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageTradeSectionAppResource";
import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
import Resources from "../../../components/LandingPage/Trade/Resources/Resources";
import Tutorial from "../../../components/LandingPage/Trade/Tutorial/Tutorial";
import GetStarted from "../../../components/LandingPage/Trade/GetStarted/GetStarted";
import ContactModal, {CONTACT_MODAL_OPEN} from "../../../components/LandingPage/Modals/ContactModal/ContactModal";


export default {
    name: "Trade",
    components: {ContactModal, GetStarted, Tutorial, Resources},
    mixins: [ShowNotificationMixin],
    data() {
        return {
            landingPageUuid: window.landingPageUuid,
            tradeSection: new LandingPageTradeSectionAppResource()
        }
    },
    methods: {
        handleClick() {
            this.$bus.$emit(CONTACT_MODAL_OPEN)
        },
        async fetchTradeSection() {
            if (!landingPageUuid) {
                return;
            }
            let search = new AppResourceSearch('landing-page-trade-section');
            search.setSearchData({
                filter: new ApiFilter({
                    params: {
                        landingPageUuid: this.landingPageUuid
                    }
                })
            })
            try {
                await search.search();
                if (search.appResourceCollection.isNotEmpty) {
                    this.tradeSection = search.appResourceCollection.getFirst();
                }
            } catch (e) {
                console.warn(e)
                this.showNotification({
                    message: `Something went wrong while fetching trade section! Please try again later!`,
                    type: 'error',
                });
            }
        },
    },
    async mounted() {
        await this.fetchTradeSection()
    }
}
</script>
